<div class="packages-container">
  <!-- Loading (no cards and no empty state until the fetch settles) -->
  <p class="loading-state" *ngIf="loading">Loading packages…</p>

  <!-- Package Cards -->
  <div
    class="package-card"
    *ngFor="let package of packages; trackBy: trackById"
    [class.selected]="package.selected"
    (click)="selectPackage(package)"
  >
    <div class="package-header">
      <div class="radio-button">
        <div class="radio-dot" *ngIf="package.selected"></div>
      </div>
      <span class="package-name">{{ package.package_name }}</span>
      <div class="package-price">
        <!-- A custom-price package carries no list price, so the currency pipe rendered the
             unset 0 as $0.00 — a detailing quote reading as free. Say what it is instead. -->
        <span class="custom-price-tag" *ngIf="isCustomPricePackage(package); else listedPrice">
          Custom price
        </span>
        <ng-template #listedPrice>
          <span class="current-price">{{ package.single_list_price | currency }}</span>
          <span class="original-price" *ngIf="hasStrikeoffPrice(package.single_strikeoff_price)">{{
            package.single_strikeoff_price | currency
          }}</span>
        </ng-template>
      </div>
    </div>
    <div class="package-details" *ngIf="package.features">
      <div class="details-column">
        <ul>
          <li
            *ngFor="
              let feature of package.features.slice(0, package.features.length / 2);
              trackBy: trackByIndex
            "
          >
            <img src="assets/images/package/check.svg" alt="check icon" />
            <span>{{ feature }}</span>
          </li>
        </ul>
      </div>
      <div class="details-column">
        <ul>
          <li
            *ngFor="
              let feature of package.features.slice(package.features.length / 2);
              trackBy: trackByIndex
            "
          >
            <img src="assets/images/package/check.svg" alt="check icon" />
            <span>{{ feature }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state-container" *ngIf="!loading && packages.length === 0">
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img src="assets/images/package/Illustrations.svg" alt="No packages illustration" />
      </div>
      <div class="empty-state-text">
        <h3 class="empty-state-title">No Packages Available</h3>
        <p class="empty-state-description">
          Create Car Wash packages before proceeding to create an appointment
        </p>
        <button class="btn btn-primary btn-medium" (click)="createPackage()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99996 1.16699V12.8337M1.16663 7.00033H12.8333"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Add Package
        </button>
      </div>
    </div>
  </div>
</div>
